// apiService.js
import axios from "axios";
import Api from "../Api/Api.json";
const API_BASE = "http://localhost:5000"; // Adjust to your Flask backend URL
const URL = "https://p6nds56ryf.execute-api.us-east-1.amazonaws.com/prod/";
const PRESCRIPTION_URL = Api.PRESCRIPTION_DATA_FETCH;

export async function getPathologyTests() {
  const res = await fetch(`${API_BASE}/tests/pathology`);
  return res.json();
}

export async function getRadiologyTests() {
  const res = await fetch(`${API_BASE}/tests/radiology`);
  return res.json();
}

export async function getMedicines() {
  const res = await fetch(`${API_BASE}/medicines`);
  return res.json();
}

export async function getPatientInfo(patientId) {
  const requestData = {
    task: "getPatientDetails",
    phone: String(patientId),
  };
  const headers = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(URL, requestData, headers);
  return response.data[0];
}

export async function createAppointment(doctorId, patientId,time_slot) {
  const requestData = {
    task: "createAppointment",
    patient_id: String(patientId),
    time_slot: time_slot,
    doctor_id: String(doctorId),
  };
  const headers = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(URL, requestData, headers);
  return response.data;
}

export async function getPatientAppointments(patientId) {
  const requestData = {
    task: "getPatientAppointmentList",
    patient_id: String(patientId),
  };
  const headers = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(URL, requestData, headers);
  return response.data;
}

export async function createAppointmentAndSubmitPrescription(doctorId,patientId,prescriptionArray,medicineArray,timeZone,prescription_dict,appointmentId,appointmentDate) {
  const requestData = {
    task: "createAppointmentAndSavePrescription",
    patient_id: String(patientId),
    doctor_id: String(doctorId),
    prescription_data: prescriptionArray,
    medicine_data: medicineArray,
    timezone: timeZone,
    prescription_dict: prescription_dict,
    appointment_id: appointmentId,
    appointment_date: appointmentDate,
  };

  if (doctorId==='undefined' || doctorId==='null'){
    alert("Doctor ID is required. Please login again.");
    return;
  }
  if (patientId==='undefined' || patientId==='null'){
    alert("Patient ID is required. Please find the patient account again.");
    return;
  }
  console.log(requestData);
  const headers = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(PRESCRIPTION_URL, requestData, headers);
  //console.log(response.data);
  return response.data;
}

export async function getPrescriptionList(patientId) {
  const requestData = {
    task: "getPrescriptionList",
    patient_id: String(patientId),
  };

  const headers = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(PRESCRIPTION_URL, requestData, headers);
  return response.data;
}

export async function getPrescriptionByDate(patientId,presc_date) {
  const requestData = {
    task: "getPrescriptionByDate",
    patient_id: String(patientId),
    presc_date: presc_date,
  };

  const headers = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(PRESCRIPTION_URL, requestData, headers);
  return response.data;
}

export async function submitPrescription(prescriptionData) {
  const headers = { headers: { "Content-Type": "application/json" } };
  const response = await axios.post(
    `${API_BASE}/prescriptions`,
    prescriptionData,
    headers
  );
  return response.data;
}

export async function getPrescriptionDataForGlobalUpload(appointment_id) {
  const headers = { headers: { "Content-Type": "application/json" } };
  const requestData = {
    lowest: appointment_id,
    highest: appointment_id,
  };
  const response = await axios.post(
    `${API_BASE}/getPrescriptionDataForUpload`,
    requestData,
    headers
  );
  return response.data;
}

export async function getMedicineDataForGlobalUpload(prescription_id) {
  const headers = { headers: { "Content-Type": "application/json" } };
  const requestData = {
    lowest: prescription_id,
    highest: prescription_id,
  };
  const response = await axios.post(
    `${API_BASE}/getMedicineDataForUpload`,
    requestData,
    headers
  );
  return response.data;
}

export async function updateServer(tableName, data) {
  const req = {
    task: "uploadDiagCenterData",
    tableName: tableName,
    valList: data,
  };
  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const response = await fetch(URL, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(req),
    });

    const jsonResponse = await response.json();
    return jsonResponse;
  } catch (error) {
    console.error(error.toString());
  }
}
